import { IonPage, IonContent } from "@ionic/react";

import { Switch } from "react-router-dom";
import { Route } from "react-router";
// Pages
import Language from "./settings/Language";
import Team from "./settings/Team";
import Payment from "./settings/Payment";
import Usage from "./settings/Usage";
import ApiKeys from "./settings/ApiKeys";

// User
import { User, Settings } from "../../../interfaces";

// Components
import SettingsNavigation from "../../../components/SettingsNavigation";
import "./Settings.css";
import CompanyProfile from "./settings/Profile";

// Guards
import ProtectedRoute from "../../../guards/role-route-guard";

const SettingsComponent: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { path, refreshUser } = props;
  return (
    <IonPage id="main-content">
      <IonContent>
        <div className="page-wrapper">
          <div className="settings-wrapper">
            <div className="menu-holder">
              <SettingsNavigation path={path} user={props.user} />
            </div>
            <div className="content-holder flex-center mh-100 overflow-auto">
              <Switch>
                <Route exact path="/settings/api" render={() => <ApiKeys />} />

                <Route
                  exact
                  path="/settings"
                  render={() => <Language user={props.user} />}
                />

                <Route
                  exact
                  path="/settings/language"
                  render={() => <Language user={props.user} />}
                />

                <ProtectedRoute
                  role={props.user.role}
                  path="/settings/team"
                  render={() => (
                    <Team
                      user={props.user}
                      settings={props.settings}
                      onRequestSettings={props.onRequestSettings}
                    />
                  )}
                />

                <ProtectedRoute
                  role={props.user.role}
                  path="/settings/profile"
                  render={() => <CompanyProfile refreshUser={refreshUser} />}
                />

                <ProtectedRoute
                  exact
                  path="/settings/payment"
                  role={props.user.role}
                  render={() => (
                    <Payment
                      user={props.user}
                      settings={props.settings}
                      onRequestSettings={props.onRequestSettings}
                    />
                  )}
                />

                <ProtectedRoute
                  exact
                  path="/settings/usage"
                  role={props.user.role}
                  render={() => (
                    <Usage
                      user={props.user}
                      settings={props.settings}
                      onRequestSettings={props.onRequestSettings}
                    />
                  )}
                />
              </Switch>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  user: User;
  path: string;
  settings: Settings;
  onRequestSettings: Function;
  refreshUser: Function;
}

export default SettingsComponent;
